export class ProductModel {
  id: string;
  baseID: string;
  calc: string;
  categoryID: string;
  categoryName: string;
  categoryBaseId: string;
  brandName: string;
  density: string;
  name: string;
  organizationID: string;
  pType: string;
  size: number;
  state: string;
  isCanister: boolean;
  lastModDate: string;
  baseValidated: boolean;
  baseImageUrl: string;
  baseUniqueCode: string;
}
